import { setFetchStartState } from '../fetchLoadable.js';
import { createNotLoaded } from '../Loadable/utils.js';
import * as actionTypes from './actionTypes.js';
export const VoucherTypesReducer = (state = createNotLoaded(), action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_ECONOMY_VOUCHER_TYPES_START:
            return { ...setFetchStartState(state, payload.res) };
        case actionTypes.FETCH_ECONOMY_VOUCHER_TYPES_SUCCESS:
        case actionTypes.FETCH_ECONOMY_VOUCHER_TYPES_ERROR:
            return { ...payload.res };
        default:
            return state;
    }
};
export const VoucherTypesMapReducer = (state = createNotLoaded(), action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_ECONOMY_VOUCHER_TYPES_START:
            return { ...setFetchStartState(state, payload.res) };
        case actionTypes.FETCH_ECONOMY_VOUCHER_TYPES_SUCCESS:
        case actionTypes.FETCH_ECONOMY_VOUCHER_TYPES_ERROR: {
            return payload.res.data.reduce((acc, voucherType) => {
                acc[voucherType.voucherTypeId] = voucherType;
                return acc;
            }, {});
        }
        default:
            return state;
    }
};
export const DepositsInsightsReducer = (state = createNotLoaded(), action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_ECONOMY_DEPOSIT_INSIGHTS:
            return { ...setFetchStartState(state, payload.res) };
        case actionTypes.FETCH_ECONOMY_DEPOSIT_INSIGHTS_SUCCESS:
        case actionTypes.FETCH_ECONOMY_DEPOSIT_INSIGHTS_ERROR:
            return { ...payload.res };
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map